module.exports = __webpack_public_path__ + "img/da_get.91e9c89.png";